module.exports = __webpack_public_path__ + "static/img/mssn.9a670cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/mssn.png
// module id = 52xl
// module chunks = 1